import React, { useMemo, useState } from 'react';
import { Row, Col, DatePicker } from 'antd';
import moment from 'moment';
import { useEnochFilterContext } from './context';
import { Select, SelectOption } from '../../../components/ui';
import {
  enochFilterDateFormat,
  dateRangeConfigs,
  mapIpToMachineName,
} from './common';
import {
  useGetAllEnochEmails,
  useGetEnochAllMachineIps,
} from '../../../query/enoch';
const { RangePicker } = DatePicker;

export default function EnochReportFilter({ setFilter }) {
  const { fromDate, toDate, ipAddress, email } = useEnochFilterContext();
  const [isCustom, setIsCustom] = useState(false);
  const { data, isLoading } = useGetEnochAllMachineIps();
  const { data: emailData, isLoading: isLoadingEmail } = useGetAllEnochEmails(
    ipAddress,
  );

  const renderDatePicker = useMemo(() => {
    const selectedDate =
      dateRangeConfigs.find(
        e => e.fromDate === fromDate && e.toDate === toDate,
      ) || dateRangeConfigs.find(e => e.id === 0);
    return (
      <>
        <Col span={6}>
          <h5> Select time range </h5>
          <Select
            style={{ width: '100%' }}
            value={isCustom ? 0 : selectedDate.id}
            onChange={id => {
              const selected = dateRangeConfigs.find(e => e.id === id);
              if (selected.id !== 0) {
                setFilter({
                  fromDate: selected.fromDate,
                  toDate: selected.toDate,
                });
              }
              setIsCustom(selected.id === 0);
            }}
          >
            {dateRangeConfigs.map(configs => (
              <SelectOption key={configs.id} value={configs.id}>
                {configs.title}
              </SelectOption>
            ))}
          </Select>
        </Col>
        {isCustom && (
          <Col span={6}>
            <h5> Custom time range </h5>
            <RangePicker
              allowClear={false}
              value={[moment(fromDate), moment(toDate)]}
              onChange={dates => {
                setFilter({
                  fromDate: moment(dates[0]).format(enochFilterDateFormat),
                  toDate: moment(dates[1]).format(enochFilterDateFormat),
                });
              }}
            />
          </Col>
        )}
      </>
    );
  }, [fromDate, toDate, setFilter, isCustom]);

  const renderMachineFilter = useMemo(() => {
    return (
      <Col span={6}>
        <h5> Filter By Machine IP </h5>
        <Select
          loading={isLoading}
          style={{ width: '100%' }}
          value={ipAddress}
          onChange={value => {
            setFilter({ ipAddress: value });
          }}
        >
          <SelectOption value={null}>Select a machine IP</SelectOption>
          {data.map(({ ipAddress: ip }) => (
            <SelectOption key={ip} value={ip}>
              {mapIpToMachineName[ip] || ip}
            </SelectOption>
          ))}
        </Select>
      </Col>
    );
  }, [data, isLoading, ipAddress]);

  const renderEmailFilter = useMemo(() => {
    return (
      <Col span={6}>
        <h5> Filter By Emails </h5>
        <Select
          loading={isLoadingEmail}
          style={{ width: '100%' }}
          value={email}
          onChange={value => {
            setFilter({ email: value });
          }}
        >
          <SelectOption value={null}>Select an email</SelectOption>
          {emailData.map(({ email: value }) => (
            <SelectOption key={value} value={value}>
              {value}
            </SelectOption>
          ))}
        </Select>
      </Col>
    );
  }, [emailData, isLoadingEmail, email]);

  return (
    <Row gutter={16}>
      {renderDatePicker}
      {renderMachineFilter}
      {renderEmailFilter}
    </Row>
  );
}
